import React from 'react'
import { useTranslation } from 'react-i18next'
import { useModalData } from '../../../components/modals/ModalsContext'
import { SmallText } from '../../../packages/kiti/components/presentation/Text'

const MultiSelectModalContent = () => {
  const { serviceOrderIds, filter } = useModalData() || {}
  const ids = serviceOrderIds || filter?.ids || []
  if (!ids.length) return null
  return null
}

export const MultiSelectExportSubtitle = () => {
  const { t } = useTranslation('export')
  const { serviceOrderIds, filter } = useModalData() || {}
  const ids = serviceOrderIds || filter?.ids || []
  if (!ids.length) return null

  const totalCount = ids.length

  return (
    <SmallText color="red" align="center" bold>
      {t('exportingSelected', { count: totalCount })}
    </SmallText>
  )
}

export default MultiSelectModalContent
